export enum OrderStatusEnum {
  Created = 1,
  Canceled = 3,
  AwaitingApproval = 4,
  AwaitingFulfillment = 5,
  AwaitingPayment = 6,
  Completed = 7,
}
